import { Box, styled } from "@mui/material";

import { palette } from "~frontend/theme";

export const DataContainer = styled(Box)({
  borderRadius: "4px",
  backgroundColor: palette.white,
});

export const EmptyDataContainer = styled(DataContainer)({
  backgroundColor: palette.lightGray,
  border: `1px solid ${palette.midGray}`,
});
